import React from 'react';

import { getParentLabel, getParentPath } from 'bundles/crm/parent_helpers';

import type { Activity } from 'bundles/apex/activities/types';
import type { Parent, ParentOption } from 'bundles/crm/types';
import { faBuildings, faHandshake, faPerson, faSign, type IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'react-bootstrap-5';

interface Props {
  activity: Activity;
  asLink?: boolean;
  currentParent?: Parent | Parent[];
  options?: {
    parents?: ParentOption[];
  }
}

export default function ActivityParent({ activity, asLink, currentParent, options }: Props) {
  const label = getParentLabel(activity, { currentParent, parentOptions: options?.parents });
  const path = asLink ? getParentPath(activity, { currentParent }) : null;
  let icon: IconDefinition | null = null;

  switch (activity.parentType) {
  case 'Project':
  case 'Listing':
    icon = faSign;
    break;
  case 'Backoffice::Contact':
    icon = faPerson;
    break;
  case 'Apex::Deal':
    icon = faHandshake;
    break;
  case 'Research::Property':
    icon = faBuildings;
    break;
  default:
    break;
  }

  return (
    <div className="d-flex align-items-center text-muted text-xs">
      {icon &&
        <Badge bg="buildout-blue-100"
          className="rounded border p-1 me-2"
          style={{ zIndex: 1, width: 18, height: 18 }}
        >
          <FontAwesomeIcon color="black" icon={icon} size="xs" />
        </Badge>
      }
      {path ?
        <a href={path}>
          {label}
        </a> :
        label
      }
    </div>
  );
}
